<template>
  <div id="app">
    <SiteHeader v-if="isConnected" :walletConnect="walletConnect" />
    <main>
      <router-view v-if="isConnected" :walletConnect="walletConnect" />
    </main>
    <SiteFooter />
  </div>
</template>

<script setup>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import { ref, defineComponent, onMounted, getCurrentInstance } from 'vue';
import { useRouter } from "vue-router";
import WalletConnect from '@/utils/walletConnect';
const { proxy } = getCurrentInstance();
const router = useRouter();
const loading = ref(false);
const setLoading = (value) => {
      loading.value = value;
      if(value){
        proxy.$toast.showMarkLoading();
      } else {
        proxy.$toast.hideMarkLoading();
      }
    }
const isConnected = ref(false);
const walletConnect = new WalletConnect(router, setLoading);


proxy.$eventBus.on('walletConnectInitialized', ()=> {
  isConnected.value = true;
});
defineComponent({
  name: 'GeneralLayout',
  components: {
    SiteHeader,
    SiteFooter,
  },
});
onMounted(()=> {
  console.log("walletConnect", walletConnect)
})
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

main {
  padding: 20px;
  min-height: calc(100vh - 120px); /* Adjust for header and footer height */
}
</style>
